// The login doors on Login.dc.html: the white Library door, then 1 per product in its own look.
// /masterclass uses Profit On Your Terms' look, as the masterclass does, with its own name
// (decision 3; Adam sees it at stage 3). Colours and fonts are in src/styles/login.css, by key.
import { productPathConfig } from './products.js'

export const DOORS = {
  library: { key: 'library', name: '' },
  cashflow: { key: 'cashflow', name: 'Property Cashflow For Life', tagline: 'The foundation of every property strategy.' },
  poyt: { key: 'poyt', name: 'Profit On Your Terms', eyebrow: 'Live cohort', tagline: 'Two offers. One yes.' },
  masterclass: { key: 'masterclass', name: 'Buy your next property without a deposit', eyebrow: 'Video' },
  fe: { key: 'fe', name: 'The Funding Engine' },
  acc: { key: 'acc', name: 'The Property Accelerator', line: "Your goal, this month's actions and every session, recorded and searchable." },
}

// Logged out, any path shows that path's door; anything that isn't a product path shows the Library's.
export function doorFor(path) {
  const p = productPathConfig(path)
  return DOORS[p ? p.door : 'library']
}
